module.exports = __webpack_public_path__ + "img/feature.ae74d824.png";